export function scrollToContent(id: string, minWidth: number = 575) {
    const contentRef = document.getElementById(id);
    const width = document.body.getBoundingClientRect().width;

    if (contentRef && width < minWidth) {
        contentRef!.scrollIntoView({behavior: 'smooth'});
    } else {
        window.scrollTo(0, 0);
    }
}